import script from "./CourtBookingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtBookingPage.vue?vue&type=script&setup=true&lang=js"

import "./CourtBookingPage.vue?vue&type=style&index=0&id=5dd8528d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd8528d"]])

export default __exports__